import { createSlice } from "@reduxjs/toolkit";

const enhancedConditionStatus = createSlice({
	name: "enhancedConditionStatus",
	initialState: {
		data: "",
	},
	reducers: {
		setEnhancedConditionStatus: (state, action) => {
			state.data = action.payload;
		},
	},
});

export const { setEnhancedConditionStatus } = enhancedConditionStatus.actions;
export default enhancedConditionStatus.reducer;

export const selectEnhancedConditionStatus = (state) =>
	state.enhancedConditionStatus?.data;
